import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const TranslationDebugger = ({ translationKey }) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    /* console.log('i18n current language:', i18n.language) */
    /* console.log('i18n loaded languages:', i18n.languages) */
    /* console.log('i18n has loaded namespaces:', i18n.options.ns) */
    /* console.log(`Direct i18n.t:`, t(translationKey)) */

    // Check if the resource exists in i18next
    const hasTranslation = i18n.exists(translationKey)
    /* console.log(`Translation key exists in i18n: ${hasTranslation}`) */

    // Check for missing resources
    if (!hasTranslation) {
      console.warn(
        `Missing translation for key: ${translationKey} in language: ${i18n.language}`
      )
    }
  }, [translationKey, t, i18n])

  return null
}
